import { tippyAlert } from 'Functions/tippy';
import Swal from 'sweetalert2';

window.Eshop.confirm = function(text, options, callback, thenCallback = null) {
    var settings = $.extend({
        title: text,
        denyButtonText: options.cancelButtonText || 'Zrušiť',
        confirmButtonText: options.confirmButtonText || 'Ok',
        buttonsStyling: false,
        showDenyButton: true,
        reverseButtons: true,
        icon: 'question',
        customClass: {
            confirmButton: 'c-btn c-btn--primary is-confirm',
            denyButton: 'c-btn c-btn--transparent is-deny'
        },
        preConfirm: () => {
            return callback()
        }
    }, options);

    Swal.fire(settings).then(thenCallback);
}

window.Eshop.tippyAlert = tippyAlert

window.Eshop.removeItem = function(elem) {
    var $elem = $(elem),
        $data = $elem.data();

    Eshop.confirm($data.confirm, {
        denyButtonText: $data.denyText,
        confirmButtonText: $data.confirmText
    }, () => {
        $elem.prop('disabled', true).addClass('is-loading');

        $.post($data.url, {'_csrfToken': getCookie('csrfToken')}, function(result) {
            if (result) {
                $($data.remove).remove();

                if ($data.reload) {
                    location.reload();
                } else {
                    $elem.prop('disabled', false).removeClass('is-loading');
                }
            } else {
                $elem.prop('disabled', false).removeClass('is-loading');
            }
        });
    })
}
